import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { DepositContext } from "@state/context/payment/DepositContext";
import { LimitSteps } from "@utils/limits/limitSteps";
import { observer } from "mobx-react";

import DepositLimitInfoMessage from "./DepositLimitInfoMessage";

export default observer(function DepositLimitNone() {
	const depositStore = useContext(DepositContext);

	const { t } = useTranslation("my-limits");

	if (depositStore.depositLimitStore.activeStep !== LimitSteps.NONE) {
		return null;
	}

	return (
		<>
			<div className="popup__body">
				<div className="message message--base message--warning">
					<i className="message__icon u-icon u-icon--lrg u-icon--alert-circle u-color--sent--warning message--centered" />
					<DepositLimitInfoMessage />
				</div>
			</div>
			<div className="popup__footer">
				<button
					type="button"
					className="at-accVerifBtnSecondary popup__btn btn btn--med btn--primary--inverted"
					onClick={
						depositStore.depositLimitStore.activateIncreaseLimitForm
					}
				>
					{t("INCREASE_LIMIT")}
				</button>

				{depositStore.depositLimitStore.limitData?.availableBudget !=
				null ? (
					<button
						type="button"
						className="popup__btn btn btn--med btn--primary--inverted"
						onClick={() => {
							depositStore.depositLimitStore.deactivateDepositLimitPopup(
								true
							);
						}}
					>
						{t("PARTIAL_DEPOSIT")}
					</button>
				) : null}
			</div>
		</>
	);
});
